import angular from 'angular';
import { NewAddressFormComponent } from './new-address-form.component';
import AddressService from '../forms/account/address/address.service';
export var NewAddressFormModule = angular
    .module('NewAddressFormModule', [])
    .component('newAddressForm', NewAddressFormComponent)
    .service('AddressService', AddressService)
    .name;
//# sourceMappingURL=new-address-form.module.js.map